import { useAtom } from 'jotai'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'
import { StoreItem } from '../models'

const { atom, resetAtom } = createAtom<Array<StoreItem>>([], MMKVKey.ScannedItems)

export const useScannedItemsAtom = () => useAtom(atom)
export const useResetScannedItemsAtom = () => useAtom(resetAtom)
